import { Button, TableCell, TableRow } from "@pushpress/pushpress-ui";
import { Plus } from "lucide-react";

type EmptyPlansTableProps = {
  numColumns: number;
  userUuid: string;
  viewMode: string;
};

export default function EmptyPlansTable({
  numColumns,
  userUuid,
  viewMode,
}: EmptyPlansTableProps) {
  const getEmptyComponents = () => {
    const addPlanButton = (
      <Button
        onClick={() =>
          window.open(
            `/members/edit/plan/${userUuid}`,
            "_blank",
            "noopener,noreferrer",
          )
        }
        size="sm"
      >
        <Plus className="tw-mr-1 tw-h-4 tw-w-4" />
        Add Plan
      </Button>
    );
    const addCreditButton = (
      <Button
        onClick={() =>
          window.open(
            `/appointments/member/${userUuid}`,
            "_blank",
            "noopener,noreferrer",
          )
        }
        size="sm"
      >
        <Plus className="tw-mr-1 tw-h-4 tw-w-4" />
        Add Credit
      </Button>
    );
    switch (viewMode) {
      case "all":
        return {
          emptyText: "No plans for this user",
          ctaText: "Add a plan to get started",
          emptyButton: addPlanButton,
        };
      case "active":
        return {
          emptyText: "No active plans for this user",
          ctaText: "Add a plan to get started",
          emptyButton: addPlanButton,
        };
      case "appointments":
        return {
          emptyText: "No appointment credits for this user",
          ctaText: "Add a credit to get started",
          emptyButton: addCreditButton,
        };
      default:
        return {
          emptyText: "No plans for this user",
          ctaText: "Add a plan to get started",
          emptyButton: addPlanButton,
        };
    }
  };
  const { ctaText, emptyText, emptyButton } = getEmptyComponents();
  return (
    <TableRow>
      <TableCell colSpan={numColumns} className="tw-h-24 tw-text-center">
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-text-center">
          <h4 className="tw-mb-2">{emptyText}</h4>
          <p className="tw-text-neutral-500 tw-mb-6">{ctaText}</p>
          <div className="tw-flex tw-gap-4">{emptyButton}</div>
        </div>
      </TableCell>
    </TableRow>
  );
}
